module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_niigata-b11a478f7b8f58bf31a250589a40576e.png";